import type PointerEventsNone from './types';

const pointerEventsNone: PointerEventsNone = {
    pointerEvents: 'none',
};

export default pointerEventsNone;
